/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreatePurchaseApplicationTemplateRequest
 */
export interface CreatePurchaseApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'scopeDisclosure': CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'templateDetail': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'purposeOfUse': CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'remarks': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePurchaseApplicationTemplateRequest
     */
    'approvers': Array<string>;
}

export const CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum = typeof CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum[keyof typeof CreatePurchaseApplicationTemplateRequestScopeDisclosureEnum];
export const CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum = typeof CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum[keyof typeof CreatePurchaseApplicationTemplateRequestPurposeOfUseEnum];


